module.exports = __webpack_public_path__ + "img/Baumgartner Josef.jpg";